import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { useShiftSwapSettings } from '@/hooks/useShiftSwapSettings';
import { RefreshCw } from 'lucide-react';

export const ShiftSwapToggle = () => {
  const { isEnabled, isLoading, toggleSwapFeature } = useShiftSwapSettings();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Shift Swap Requests</CardTitle>
        <CardDescription>
          Allow guards to request shift swaps with other guards within the same week
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <div className="text-sm font-medium">Enable Shift Swaps</div>
            <div className="text-sm text-muted-foreground">
              Guards can request to swap shifts with validation rules applied
            </div>
          </div>
          {isLoading ? (
            <RefreshCw className="h-5 w-5 animate-spin text-muted-foreground" />
          ) : (
            <Switch
              checked={isEnabled}
              onCheckedChange={toggleSwapFeature}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
};
